<h1 mat-dialog-title>Editer lien PowerBI</h1>
<div mat-dialog-content>
  <p>Lien PowerBI:</p>
  <input [(ngModel)]="powerBILink" />
</div>
<div mat-dialog-actions>
  <button mat-button (click)="close()">Annuler</button>
  <button mat-button color="primary" (click)="confirm()">Confirmer</button>
</div>
